/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bidbattle__Status__Full4Inputs */

const en_bidbattle__status__full4 = /** @type {(inputs: Bidbattle__Status__Full4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full`)
};

/**
* | output |
* | --- |
* | "Full" |
*
* @param {Bidbattle__Status__Full4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const bidbattle__status__full4 = /** @type {((inputs?: Bidbattle__Status__Full4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bidbattle__Status__Full4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bidbattle__status__full4(inputs)
});
export { bidbattle__status__full4 as "bidbattle__status__FULL" }